import React, { PropsWithChildren } from 'react';
import { IBuyboxData, IBuyboxViewProps } from '@msdyn365-commerce-modules/buybox';
import { IQuickviewViewProps } from '@msdyn365-commerce-modules/buybox/src/modules/quickview/./quickview';
import { IBuyboxProps } from '../../themes/krannich/definition-extensions/buybox.ext.props.autogenerated';
import { ProductAvailableQuantity } from '@msdyn365-commerce/retail-proxy';
import { generateImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { ICartViewProps } from '../../modules/krannich-c-cart/krannich-c-cart';
interface CommercePropertyValue {
    BooleanValue?: boolean;
    ByteValue?: number;
    DateTimeOffsetValue?: Date;
    DecimalValue?: number;
    IntegerValue?: number;
    LongValue?: number;
    StringValue?: string;
}

interface CommerceProperty {
    Key?: string;
    Value?: CommercePropertyValue;
}
interface AttributeSwatch {
    SwatchValue?: string;
    SwatchImageUrl?: string;
    SwatchColorHexCode?: string;
    IsDefault?: boolean;
    ProductImageUrls?: string[];
    ExtensionProperties?: CommerceProperty[];
}
interface AttributeValue {
    Name?: string;
    KeyName?: string;
    UnitOfMeasureSymbol?: string;
    DataTypeValue?: number;
    BooleanValue?: boolean;
    DateTimeOffsetValue?: Date;
    FloatValue?: number;
    IntegerValue?: number;
    TextValue?: string;
    CurrencyValue?: number;
    CurrencyCode?: string;
    AttributeValueId?: number;
    RecordId?: number;
    Swatches?: AttributeSwatch[];
    ExtensionProperties?: CommerceProperty[];
}
interface customAttribute {
    attributevalues?: AttributeValue[];
}
export const KitProduct = ({
    linkedProducts,
    props
}: {
    linkedProducts: any[] | undefined;
    props:
        | PropsWithChildren<IBuyboxViewProps & IBuyboxProps<IBuyboxData> & ProductAvailableQuantity>
        | (IQuickviewViewProps & customAttribute)
        | ICartViewProps;
}) => {
    return (
        <div className='bundle-wrapper'>
            <div className='bundle-header'>
                <h2>Bundle Contains</h2>
                <span className='count'>{linkedProducts?.length.toString()} Items</span>
            </div>
            <div className='bundle-items'>
                {linkedProducts &&
                    linkedProducts?.map((e: any, index: number) => {
                        return (
                            <div className='bundle-container' key={index}>
                                <div className='bundle-image'>
                                    <img
                                        src={generateImageUrl(
                                            e.Product?.PrimaryImageUrl,
                                            props.context.actionContext.requestContext.apiSettings
                                        )}
                                        alt={'Bundle Product ALT'}
                                    />
                                </div>
                                <div className='bundle-content'>
                                    <h1 className='bundle-item-name'>{e.Name!}</h1>
                                    <div className='bundle-detail-container'>
                                        <div className='bundle-price-container'>
                                            <div className='bundle-item-quantity'>
                                                <span className='_title'>{'Item number: '}</span>
                                                <span className='_quantity'>{e.ItemId!}</span>
                                            </div>
                                            {/*<div className='bundle-item-price'>
                                                <span className='_title'>{'Price:'} </span>
                                                <span className='_price'>
                                                    {props.context.cultureFormatter.formatCurrency(Number(e.Product?.Price!))}
                                                </span>
                                        </div>*/}
                                            <div className='bundle-item-quantity'>
                                                <span className='_title'>{'Quantity: '}</span>
                                                <span className='_quantity'>{e.Quantity!}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </div>
    );
};
